import { Observable } from "../Observable.js";
function debounceTime(duration, config) {
  return (source) => {
    return new Observable((subscriber) => {
      const setTimeoutFn = config?.setTimeout || setTimeout;
      const clearTimeoutFn = config?.clearTimeout || clearTimeout;
      let timeoutId = null;
      let lastValue;
      let hasValue = false;
      const subscription = source.subscribe({
        next: (value) => {
          clearTimeoutFn(timeoutId);
          lastValue = value;
          hasValue = true;
          timeoutId = setTimeoutFn(() => {
            if (hasValue) {
              subscriber.next(lastValue);
              hasValue = false;
            }
          }, duration);
        },
        error: (err) => {
          clearTimeoutFn(timeoutId);
          subscriber.error(err);
        },
        complete: () => {
          clearTimeoutFn(timeoutId);
          if (hasValue) {
            subscriber.next(lastValue);
          }
          subscriber.complete();
        }
      });
      return subscription;
    });
  };
}
export {
  debounceTime
};
//# sourceMappingURL=debounceTime.js.map
